module.exports = __webpack_public_path__ + "static/media/audiencia-total.9abf9965.png";